import { b as y, r as i, i as w, f as Q, a as Y } from "./isArray.CdbPONHA.js";
import { jsx as c, jsxs as Z } from "react/jsx-runtime";
import { useState as rr, useEffect as T } from "react";
import { c as D } from "./clsx.OuTLNxxd.js";
import { RichText as U } from "@sitecore-jss/sitecore-jss-nextjs";
import { NeuAlertContextual as tr } from "@hcahealthcaredpx/neutron-react";
function W(r) {
  var t = typeof r;
  return r != null && (t == "object" || t == "function");
}
var er = "[object AsyncFunction]", ar = "[object Function]", or = "[object GeneratorFunction]", nr = "[object Proxy]";
function G(r) {
  if (!W(r))
    return !1;
  var t = y(r);
  return t == ar || t == or || t == er || t == nr;
}
var m = i["__core-js_shared__"], I = function() {
  var r = /[^.]+$/.exec(m && m.keys && m.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function sr(r) {
  return !!I && I in r;
}
var cr = Function.prototype, ir = cr.toString;
function u(r) {
  if (r != null) {
    try {
      return ir.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
var ur = /[\\^$.*+?()[\]{}|]/g, fr = /^\[object .+?Constructor\]$/, pr = Function.prototype, gr = Object.prototype, br = pr.toString, yr = gr.hasOwnProperty, jr = RegExp(
  "^" + br.call(yr).replace(ur, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function lr(r) {
  if (!W(r) || sr(r))
    return !1;
  var t = G(r) ? jr : fr;
  return t.test(u(r));
}
function mr(r, t) {
  return r == null ? void 0 : r[t];
}
function j(r, t) {
  var e = mr(r, t);
  return lr(e) ? e : void 0;
}
var v = j(i, "WeakMap"), dr = 9007199254740991;
function K(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= dr;
}
function Tr(r) {
  return r != null && K(r.length) && !G(r);
}
var vr = Object.prototype;
function L(r) {
  var t = r && r.constructor, e = typeof t == "function" && t.prototype || vr;
  return r === e;
}
var $r = "[object Arguments]";
function M(r) {
  return w(r) && y(r) == $r;
}
var q = Object.prototype, xr = q.hasOwnProperty, Pr = q.propertyIsEnumerable, Ar = M(/* @__PURE__ */ function() {
  return arguments;
}()) ? M : function(r) {
  return w(r) && xr.call(r, "callee") && !Pr.call(r, "callee");
};
function wr() {
  return !1;
}
var R = typeof exports == "object" && exports && !exports.nodeType && exports, S = R && typeof module == "object" && module && !module.nodeType && module, Or = S && S.exports === R, C = Or ? i.Buffer : void 0, hr = C ? C.isBuffer : void 0, Ir = hr || wr, Mr = "[object Arguments]", Sr = "[object Array]", Cr = "[object Boolean]", kr = "[object Date]", Er = "[object Error]", Nr = "[object Function]", Br = "[object Map]", Fr = "[object Number]", Vr = "[object Object]", _r = "[object RegExp]", Dr = "[object Set]", Ur = "[object String]", Wr = "[object WeakMap]", Gr = "[object ArrayBuffer]", Kr = "[object DataView]", Lr = "[object Float32Array]", qr = "[object Float64Array]", Rr = "[object Int8Array]", zr = "[object Int16Array]", Hr = "[object Int32Array]", Jr = "[object Uint8Array]", Xr = "[object Uint8ClampedArray]", Qr = "[object Uint16Array]", Yr = "[object Uint32Array]", a = {};
a[Lr] = a[qr] = a[Rr] = a[zr] = a[Hr] = a[Jr] = a[Xr] = a[Qr] = a[Yr] = !0;
a[Mr] = a[Sr] = a[Gr] = a[Cr] = a[Kr] = a[kr] = a[Er] = a[Nr] = a[Br] = a[Fr] = a[Vr] = a[_r] = a[Dr] = a[Ur] = a[Wr] = !1;
function Zr(r) {
  return w(r) && K(r.length) && !!a[y(r)];
}
function rt(r) {
  return function(t) {
    return r(t);
  };
}
var z = typeof exports == "object" && exports && !exports.nodeType && exports, b = z && typeof module == "object" && module && !module.nodeType && module, tt = b && b.exports === z, d = tt && Q.process, k = function() {
  try {
    var r = b && b.require && b.require("util").types;
    return r || d && d.binding && d.binding("util");
  } catch {
  }
}(), E = k && k.isTypedArray, et = E ? rt(E) : Zr;
function at(r, t) {
  return function(e) {
    return r(t(e));
  };
}
var ot = at(Object.keys, Object), nt = Object.prototype, st = nt.hasOwnProperty;
function ct(r) {
  if (!L(r))
    return ot(r);
  var t = [];
  for (var e in Object(r))
    st.call(r, e) && e != "constructor" && t.push(e);
  return t;
}
var $ = j(i, "Map"), x = j(i, "DataView"), P = j(i, "Promise"), A = j(i, "Set"), N = "[object Map]", it = "[object Object]", B = "[object Promise]", F = "[object Set]", V = "[object WeakMap]", _ = "[object DataView]", ut = u(x), ft = u($), pt = u(P), gt = u(A), bt = u(v), s = y;
(x && s(new x(new ArrayBuffer(1))) != _ || $ && s(new $()) != N || P && s(P.resolve()) != B || A && s(new A()) != F || v && s(new v()) != V) && (s = function(r) {
  var t = y(r), e = t == it ? r.constructor : void 0, o = e ? u(e) : "";
  if (o)
    switch (o) {
      case ut:
        return _;
      case ft:
        return N;
      case pt:
        return B;
      case gt:
        return F;
      case bt:
        return V;
    }
  return t;
});
var yt = "[object Map]", jt = "[object Set]", lt = Object.prototype, mt = lt.hasOwnProperty;
function It(r) {
  if (r == null)
    return !0;
  if (Tr(r) && (Y(r) || typeof r == "string" || typeof r.splice == "function" || Ir(r) || et(r) || Ar(r)))
    return !r.length;
  var t = s(r);
  if (t == yt || t == jt)
    return !r.size;
  if (L(r))
    return !ct(r).length;
  for (var e in r)
    if (mt.call(r, e))
      return !1;
  return !0;
}
const H = ({
  children: r,
  className: t,
  level: e = "2",
  textAlignment: o = "start",
  marginBottom: f = "2",
  ...n
}) => {
  if (!r) return null;
  const p = `h${e}`;
  return /* @__PURE__ */ c(
    p,
    {
      className: D(`mb-${f} text-${o} text-wrap`, t),
      ...n,
      children: r
    }
  );
}, dt = ({
  showAlert: r,
  durationInSeconds: t = 10,
  clearErrorState: e,
  children: o,
  ...f
}) => {
  const [n, p] = rr(!1), g = t * 1e3;
  return T(() => {
    r && p(!0);
  }, [r]), T(() => {
    if (r) {
      const l = setTimeout(() => {
        e == null || e(""), p(!1);
      }, g);
      return () => {
        clearTimeout(l);
      };
    }
  }, [g, r, e]), n && r ? /* @__PURE__ */ c(tr, { ...f, children: o }) : null;
}, Tt = ({
  children: r,
  className: t = "my-3",
  textAlignment: e = "start",
  level: o = "3",
  titleText: f,
  descriptionRichText: n,
  titleClassName: p = "fw-heavy mb-4",
  shouldFocusContentTitle: g = !1,
  errorMessage: l,
  errorDisplayDurationInSeconds: J,
  componentName: O,
  ...X
}) => (T(() => {
  if (!g) return;
  const h = document.getElementById("page-title-to-focus");
  h && h.focus();
}, [g]), /* @__PURE__ */ Z(
  "div",
  {
    className: D(`text-${e}`, t),
    ...O ? { "data-test-id": O } : {},
    ...X,
    children: [
      f && /* @__PURE__ */ c(
        H,
        {
          level: o,
          textAlignment: e,
          className: p,
          tabIndex: g ? -1 : void 0,
          id: "page-title-to-focus",
          children: f
        }
      ),
      /* @__PURE__ */ c(
        dt,
        {
          showAlert: !!l,
          kind: "error",
          durationInSeconds: J,
          className: "mb-3",
          children: l
        }
      ),
      (n == null ? void 0 : n.value) && /* @__PURE__ */ c(U, { field: n, className: "pt-4" }),
      r
    ]
  }
)), vt = ({
  children: r,
  className: t = "neu-text-caption"
}) => r ? /* @__PURE__ */ c("div", { className: t, children: r }) : null, $t = ({ fieldContent: r, className: t }) => r ? /* @__PURE__ */ c(U, { field: r, className: t }) : null, Mt = Object.assign(Tt, {
  Title: H,
  NodeContent: vt,
  RichTextContent: $t
});
export {
  H as M,
  Mt as P,
  dt as T,
  Ar as a,
  Ir as b,
  et as c,
  ct as d,
  Tr as e,
  W as f,
  j as g,
  L as h,
  It as i,
  $ as j,
  s as k,
  rt as l,
  k as n,
  at as o
};
